<template>
  <rmr-autocomplete
    v-model="selected"
    :items="items"
    item-text="name"
    item-value="id"
    multiple
    no-chips
    v-bind="$attrs"
  >
    <template v-for="(_, name) in $scopedSlots" v-slot:[name]="slotData">
      <slot :name="name" v-bind="slotData || {}" />
    </template>
  </rmr-autocomplete>
</template>

<script>
import isEqual from 'lodash/isEqual'
import { computed, onMounted, reactive, watch } from '@vue/composition-api'
import useProxy from '@/hooks/useProxy'
import useQueryString from '@/hooks/useQueryString'
import RmrAutocomplete from '@/components/ui/forms/RmrAutocomplete.vue'
import { URL_PARAM_NAMES } from '@/utils/constants'

const URL_PARAM = URL_PARAM_NAMES.SiteGroupFilter

export default {
  name: 'V2SiteGroupFilter',
  inheritAttrs: false,
  components: { RmrAutocomplete },
  props: {
    store: {
      type: String,
      required: true,
    },
    storeGetter: {
      type: String,
      default: 'getSiteGroups',
    },
    storeUpdater: {
      type: String,
      default: 'updateSiteGroups',
    },
  },
  setup(props) {
    const { store } = useProxy()
    const { addQueryStringParam, synchronizeFilterWithQueryString } = useQueryString()

    const page = reactive({ isInitialized: false })

    const items = computed(() => store.getters['common/getSiteGroupList'])

    const selected = computed({
      get: () => store.getters[`${props.store}/${props.storeGetter}`],
      set: (val) => store.dispatch(`${props.store}/${props.storeUpdater}`, val),
    })

    watch(selected, (newValue) => {
      if (!page.isInitialized) return
      addQueryStringParam({ param: URL_PARAM, value: newValue, is_multiple: true, is_integer: true })
    })

    onMounted(async () => {
      await store.dispatch('common/getSiteGroupList')

      const synced = await synchronizeFilterWithQueryString({
        dispatcher: `${props.store}/${props.storeUpdater}`,
        param: URL_PARAM,
        value: selected.value,
        is_multiple: true,
        is_integer: true,
      })

      if (synced?.length > 0 && !isEqual(synced, selected.value)) {
        store.dispatch(`${props.store}/${props.storeUpdater}`, synced)
      }

      page.isInitialized = true
    })

    return { items, selected }
  },
}
</script>
